import { DeleteRequest } from "@/api/models/DeleteRequest";

export const ToDeleteRequest = (id: number): DeleteRequest => {
  return { ids: [id] };
};
